export type NodeEnvironment = 'development' | 'production';
export type ThemeType = 'Dark' | 'Light';
export const FA_LOCATOR_ID = `fa-editorial-columns`;
export const FA_LOCATOR = `[data-test-id=${FA_LOCATOR_ID}]`;

export interface NumbersItem {
  number: string;
  title?: string;
  unit?: string;
  description?: string;
  cta?: ButtonItem;
}

export interface ButtonItem {
  variant: 'text' | 'secondary';
  label: string;
  url: string;
  openInTabOrLayer?: 'page' | 'tab' | 'layer';
  ariaLabel?: string;
}
export interface TextItem {
  title?: string;
  description?: string;
  cta?: ButtonItem;
}

export interface HeadingOption {
  heading: string;
  headingTag: HeadingTag;
}

export interface NumbersContent {
  components: NumbersItem[];
  themeColor?: ThemeType;
  headline?: string;
  caeIdentifier?: string[];
  disclaimers?: string[];
}

export interface ComponentContainerOptions {
  delay: string;
  alignmentNumbers?: Alignment;
  flexibleWidth?: boolean;
}

export interface NumberAndHeadlineOption {
  alignmentNumbers: Alignment;
}

export interface TextComponentContainerProps {
  textAlignment: Alignment;
}

export enum ModuleType {
  TEXT = 'text',
  NUMBERS = 'numbers',
}

export enum Alignment {
  LEFT = 'left',
  CENTER = 'center',
}

export type HeadingTag = 'h2' | 'h3' | 'h4';

export interface EditorialColumnsFACE {
  alignmentNumbers: 'center';
  themeOption?: {
    theme?: ThemeType;
  };
  flexibleWidth: boolean;
  moduleContent: ModuleTextMode | ModuleNumbersMode;
  textAlignment: Alignment;
  headingOption?: HeadingOption;
  caeIdentifierOption?: string[];
  disclaimersOption?: string[];
}
export interface ModuleTextMode {
  type: ModuleType.TEXT;
  components?: TextItem[];
}

export interface ModuleNumbersMode {
  type: ModuleType.NUMBERS;
  components?: NumbersItem[];
}

interface BaseMode {
  theme: ThemeType;
  headingOption?: HeadingOption;
  textAlignment: Alignment;
  caeIdentifier?: string[];
  disclaimers?: string[];
}
export interface TextMode extends BaseMode {
  type: ModuleType.TEXT;
  components: TextItem[][];
}
export interface NumbersMode extends BaseMode {
  type: ModuleType.NUMBERS;
  components: NumbersItem[][];
  flexibleWidth: boolean;
  alignmentNumbers: Alignment;
}

export type EditorialColumnsProps = TextMode | NumbersMode;
